import { Loading, NoData } from "components/commons";
import { ACCESS_TOKEN, getItem } from "local-storage";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getTiktokUserHoldersById } from "services/apis/apis";

export const HoldersCard: React.FC<any> = (props) => {
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const f = async () => {
      const accessToken = getItem(ACCESS_TOKEN) || "";
      if (!accessToken || !props?.state?.tiktok_user_id) {
        setIsLoading(false);
        return;
      }
      try {
        setIsLoading(true);
        const result = await getTiktokUserHoldersById(
          accessToken,
          props?.state?.tiktok_user_id!
        );
        setData(result);
      } catch (error) {
        console.log("🚀 ~ file: HoldCard.tsx:21 ~ f ~ error:", error);
      } finally {
        setIsLoading(false);
      }
    };
    f();
  }, [props?.state?.tiktok_user_id]);

  return (
    <div className="flex flex-col gap-3">
      {isLoading && <Loading />}

      {!isLoading && data?.length === 0 && <NoData />}

      {!isLoading &&
        data?.map((el: any) => (
          <div
            className="border-2 rounded-xl border-gray-800 w-full"
            key={el?.id}
          >
            <div className={`flex p-4 gap-4 justify-between items-center `}>
              <div className="flex items-center gap-4 w-full">
                <div className="h-10 w-10 shadow-sm rounded-full overflow-hidden flex justify-center items-center">
                  <img
                    className="h-10 w-10 shadow-sm rounded-full object-fill"
                    src={
                      el?.metadata?.avatar_168x168 || "/images/fantech-logo.png"
                    }
                    alt=""
                  />
                </div>

                <div className="flex-1 flex justify-between items-center">
                  <div className={`text-sm font-normal leading-none mr-1`}>
                    {el?.nickname ?? "-"}
                  </div>
                  <div className="text-base font-normal text-slate-300 flex items-center gap-2">
                    <span>{el?.total_shares ?? 8}</span>
                    <div className="w-6 h-6 rounded-full bg-[#279EFF] border-[3px] border-[#51B1FF] text-white text-xs font-bold flex justify-center items-center">
                      S
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
